'use client'

import { useState, useEffect } from 'react'
import MailingList from './MailingList'
import { usePathname } from 'next/navigation'

export default function MailingListPopup() {
  const [isOpen, setIsOpen] = useState(false)
  const [isClient, setIsClient] = useState(false)
  const pathname = usePathname()
  
  // Ensure we're on the client side
  useEffect(() => {
    setIsClient(true)
  }, [])
  
  useEffect(() => {
    if (!isClient) return

    // Don't show popup on the Join page
    if (pathname === '/network') {
      return;
    }
    
    // Check if user has already subscribed or declined
    const hasSubscribed = localStorage.getItem('newsletter_subscribed')
    const hasDeclined = localStorage.getItem('newsletter_declined')
    
    console.log('Popup check:', { hasSubscribed, hasDeclined, pathname })
    
    // For development/testing: always show popup if localStorage is cleared
    const forceShow = localStorage.getItem('force_show_popup') === 'true'
    
    if (!hasSubscribed && !hasDeclined || forceShow) {
      // Show popup after 3 seconds
      const timer = setTimeout(() => {
        console.log('Showing mailing list popup')
        setIsOpen(true)
        // Clear the force show flag after showing
        if (forceShow) {
          localStorage.removeItem('force_show_popup')
        }
      }, 3000)
      return () => clearTimeout(timer)
    } else {
      console.log('Popup not shown - user has already interacted:', { hasSubscribed, hasDeclined })
    }
  }, [pathname, isClient])

  const handleSuccess = () => {
    console.log('Newsletter subscription successful')
    // Set the localStorage flag immediately
    if (typeof window !== 'undefined') {
      localStorage.setItem('newsletter_subscribed', 'true')
    }
    
    // Add a 5-second delay before closing the popup
    setTimeout(() => {
      setIsOpen(false)
    }, 5000)
  }

  const handleDecline = () => {
    console.log('User declined newsletter subscription')
    // Store the user's preference
    if (typeof window !== 'undefined') {
      localStorage.setItem('newsletter_declined', 'true')
    }
    setIsOpen(false)
  }

  const handleClose = () => {
    console.log('User closed popup manually')
    setIsOpen(false)
  }

  // Don't render the component at all when on the Join page or not on client
  if (pathname === '/network' || !isClient) {
    return null
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-xl font-bold">Subscribe to Our Mailing List</h2>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 text-xl font-bold"
            aria-label="Close popup"
          >
            ✕
          </button>
        </div>
        <p className="text-gray-600 mb-4">
          Stay updated with our latest news and updates!
        </p>
        <MailingList onSuccess={handleSuccess} uniqueId="popup" />
        <div className="mt-4 text-center">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-md transition-colors duration-200 border border-gray-300 hover:border-gray-400"
          >
            I don&apos;t wish to subscribe at this time
          </button>
        </div>
      </div>
    </div>
  )
} 